<div class="container" >
    <div  class ="innercontainer" *ngFor="let documentation of ApiDocumentations; index as i">
      <button class="collapsible" [ngStyle]="{'background-color':theme_color==='dark'?'#555':'#C8C8C8'}"><div class="method">
        {{documentation.method}}</div><div class="name" [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">{{documentation.name}}</div></button>
       
      <div class="content" [ngStyle]="{'background-color':theme_color==='dark'?'#1E1E1E':'#EBEBEB','color':theme_color==='dark'?'white':'black'}">
        <div class="url">
          <b [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">URL : </b><sh-input-text [label]="url" (value-changed)="changeValue($event,documentation,documentation.url,'url')" [value]="documentation.url"></sh-input-text>
        </div>
        <div class="description" [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">
          <b [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">Description: </b><span>{{documentation.description}}</span>
        </div>
        <span *ngIf="documentation.requestBody.length>0" [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">Request Body: </span>
        <div class="paramscontainer">
          <div class="params" *ngFor="let requestbody of documentation.requestBody" [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">
            <b>{{requestbody.name}}</b>
            <textarea (change)="changeValue($event,documentation,requestbody.name,'requestBody')" *ngIf="requestbody.type=='JSON'">
              {{requestbody.defaultValue}}
            </textarea>
            <sh-input-text [label]="requestbody.name" (value-changed)="changeValue($event,documentation,requestbody.name,'requestBody')" [value]="header.defaultValue" *ngIf="requestbody.type=='text'"></sh-input-text>
            <div *ngIf="requestbody.type=='File'" class="fileuploaddiv">
              <input type="file"  name="file"
              id="file"
              multiple="true"
              (change)="addFile($event,documentation,requestbody.name)"
              >            
            </div>
          </div>
        </div>
        <span [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">Headers: </span>
          <div class="headerscontainer">
            <div class="header" *ngFor="let header of documentation.headers">
               <sh-input-text (value-changed)="changeValue($event,documentation,header.name,'headers')" [label]="header.name"  [value]="header.defaultValue"></sh-input-text>
            </div>
          </div>
          <div class="executecontainer">
            <sh-button label='Try out' (click)="executeApi(documentation)"></sh-button>
          </div>
          <div *ngIf="currentApi==documentation.url" class="responseContainer">
            <p><b [ngStyle]="{'color':theme_color==='dark'?'white':'black'}">Result</b></p>
            <div>
              {{response | json}}
            </div>
          </div>
      </div>
    </div>
</div>
<div>
  <div id="overlay" *ngIf="loader">
      <div class="loader">
          <sh-spinner label="Loading"></sh-spinner>
      </div>
  </div>
</div>
